module.exports = require("@gauzy/plugin-camshot");